import { connect } from 'react-redux';
import { List } from 'immutable';

import decorate from '../../utils/decorate';

import { request as settleManually } from '../../modules/bets/actions/settle-manually';
import { request as comment } from '../../modules/bets/actions/comment-bet';
import { request as park } from '../../modules/bets/actions/park-bet';
import { request as cancel } from '../../modules/bets/actions/cancel-bet';
import { request as settle } from '../../modules/bets/actions/settle';
import { request as calculatePayout } from '../../modules/bets/actions/calculate-payout';
import { request as betUnsettlement } from '../../modules/bets/actions/unsettlement';
import { request as queryAudit } from '../../modules/audits/actions/query';

import BetSearchResults from './BetSearchResults.jsx';

import injectPermissions from '../../utils/permissionsInject';

function mapStateToProps(state) {
    return {
        manualSettlements: state.bets.get('manualSettlements'),
        payouts: state.bets.get('payouts')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSettleManuallyRequest: (id, accountId, payout) => dispatch(settleManually(id, accountId, payout)),
        onCommentBetRequest: (id, accountId, text) => dispatch(comment(id, accountId, text)),
        onParkBetRequest: (id, accountId, status) => dispatch(park(id, accountId, status)),
        onCancelBetRequest: (id, accountId) => dispatch(cancel(id, accountId)),
        onSettleBetRequest: (id, accountId, legs) => dispatch(settle(id, accountId, legs)),
        onCalculatePayoutRequest: (id, accountId, legs) => dispatch(calculatePayout(id, accountId, legs)),
        onBetUnsettlementRequest: (id, accountId) => dispatch(betUnsettlement(id, accountId)),
        onQueryAuditsRequest: (id, data) => {
            dispatch(queryAudit(id, data));
        }
    };
}

export default decorate(
    connect(injectPermissions(mapStateToProps), mapDispatchToProps),
    BetSearchResults
);
